module.exports = __webpack_public_path__ + "img/tick.b05c5ce3.svg";